/**
 * KEY==Value for equality checks
 */
export enum GNSSSourceEnum {
  AUTO = 'AUTO',
  GNSS_INTERN = 'GNSS_INTERN',
  GNSS_MACHINE = 'GNSS_MACHINE'
}
